import type { MonarchResponse } from '@hen-site/types/monarch';

export const defaultMonarchResponse: MonarchResponse = {
  placedTopAsset: null,
  placedHeroAsset: null,
  placedBottomAsset: null,
  topOfPageRule: { content: { rendered: '' } },
  bottomOfPageRule: { content: { rendered: '' } },
  heroRule: { content: { rendered: '' } },
  joQDF: {
    data: {
      PersonalizedAssetType: 'default',
      PersonalizedAssetData: {},
    },
  },
  internationalTrafficBrands: '',
  vipExperience: false,
  monetizationDisabled: false,
  isMonarchLoading: true,
  defaultJoSvgColor: '',
  embeddedVoyager: false,
  stickyQdfEditable: {},
  voyagerVsStudymatch: {
    monetizationExperience: '',
    excludedDcs: [],
  },
};
